const parseCards = (cardText) => {
  if (!cardText || typeof cardText !== 'string') {
    throw new Error('Invalid card data format');
  }
  
  const cardTypes = ['Normal Monster Card', 'Effect Monster Card', 'Fusion Monster Card', 'Ritual Monster Card', 'Magic Card', 'Trap Card', 'Magic Card - Equip', 'Magic Card - Field', 'Magic Card - Ritual', 'Magic Card - Quick', 'Magic Card - Continuous', 'Trap Card - Equip', 'Trap Card - Counter', 'Trap Card - Continuous', 'Normal Monster Card - Fusion-Material Monster', 'Fusion/Effect Monster Card', 'Ritual/Effect Monster Card', 'Fusion Monster Card - Fusion-Material Monster', 'Effect Monster Card - Fusion-Material Monster', 'Effect Monster Card - Fusion-Material Card'];
  const cards = [];
  let currentSection = '';
  const seenCards = new Set(); // Track cards to avoid duplicates
  
  // Split into sections by the line of asterisks
  const sections = cardText.split('******************************************************************************');
  
  // Skip the first section (it's the intro text)
  for (let sectionIndex = 1; sectionIndex < sections.length; sectionIndex++) {
    const section = sections[sectionIndex];
    if (!section.trim()) continue;
    
    try {
      const lines = section.trim().split('\n').map(line => line.trim()).filter(line => line);
      let currentCard = null;
      
      // First line should be the section letter
      if (lines[0].length === 1 && lines[1] === '=') {
        currentSection = lines[0];
        // console.log(`Processing section: ${currentSection}`);
        lines.splice(0, 2); // Remove section header and equals sign
      }
      
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        
        // Start a new card when we find a name (line before Password:)
        if (i < lines.length - 1 && (lines[i + 1].startsWith('Password:') || lines[i + 1].startsWith('No Password:'))) {
          // Add the previous card if it exists
          if (currentCard && currentCard.name && currentCard.password) {
            const cardKey = `${currentCard.name}-${currentCard.password}`;
            if (!seenCards.has(cardKey)) {
              cards.push({...currentCard});
              seenCards.add(cardKey);
              // console.log(`Added card: ${currentCard.name} in section ${currentCard.section}`);
            }
          }
          currentCard = {
            name: line.replace(/\[Limited to only \d cards* in a deck\]/, ''),
            restriction: 3,
            password: '',
            image: '',
            booster: '',
            cardType: '',
            level: '',
            atk: '',
            def: '',
            type: '',
            attribute: '',
            description: '',
            section: currentSection
          };
          if(line.includes('[Limited to only 1 card in a deck]')) {
            currentCard.restriction = 1;
          } else if(line.includes('[Limited to only 2 cards in a deck]')) {
            currentCard.restriction = 2;
          }
          // console.log(`Found new card: ${line} in section ${currentSection}`);
        } else if (currentCard) {
          if (line.startsWith('Password:')) {
            currentCard.password = line.split(':')[1]?.trim() || '';
            currentCard.image = `${currentCard.password}.jpg`;
          } else if(line.startsWith('No Password:')) {
            currentCard.password = 'None';
            currentCard.image = `${line.split(':')[1]?.trim() || ''}.jpg`;
          }else if (line.startsWith('Booster:')) {
            currentCard.booster = line.substring(8).trim();
          } else if(cardTypes.includes(line.trim())) {
            let cardType = line.trim();
            if(cardType === 'Normal Monster Card - Fusion-Material Monster') {
              cardType = 'Normal Monster Card';
            } else if(cardType === 'Fusion/Effect Monster Card' || cardType === 'Fusion Monster Card - Fusion-Material Monster') {
              cardType = 'Fusion Monster Card';
            } else if(cardType === 'Effect Monster Card - Fusion-Material Monster' || cardType === 'Effect Monster Card - Fusion-Material Card') {
              cardType = 'Effect Monster Card';
            } else if(cardType === 'Ritual/Effect Monster Card') {
              cardType = 'Ritual Monster Card';
            }
            currentCard.cardType = cardType;
          }
          else if (line.startsWith('Level')) {
            const parts = line.split(/\s+/);
            currentCard.level = parts[1] || '';
            currentCard.atk = parts[3] || '';
            currentCard.def = parts[5] || '';
          } else if (!line.includes('Password:')) {
            const parts = line.split(/\s+/).filter(x => x);
            if (parts.length === 2 && !line.startsWith('"')) {
              currentCard.type = parts[0];
              currentCard.attribute = parts[1];
            } else if (!currentCard.description && line.startsWith('"')) {
              currentCard.description = line.replace(/"/g, '');
            } else if(currentCard.description) {
              currentCard.description += ' ' + line.replace(/"/g, '');
            }
          }
        }
      }

      // Add the last card of the section
      if (currentCard && currentCard.name && currentCard.password) {
        const cardKey = `${currentCard.name}-${currentCard.password}`;
        if (!seenCards.has(cardKey)) {
          cards.push({...currentCard});
          seenCards.add(cardKey);
          // console.log(`Added last card of section: ${currentCard.name} in section ${currentCard.section}`);
        }
      }
    } catch (error) {
      // console.error('Error parsing card section:', error);
      continue;
    }
  }

  // Sort cards by section and name
  const sortedCards = [...cards].sort((a, b) => {
    // Special handling for "#" section to always come first
    if (a.section === '#' && b.section !== '#') return -1;
    if (b.section === '#' && a.section !== '#') return 1;
    // If both cards are in the same section, sort by name
    if (a.section === b.section) {
      return a.name.localeCompare(b.name);
    }
    // Otherwise sort by section
    return a.section.localeCompare(b.section);
  });

  // Debug output
  // console.log('Total cards:', sortedCards.length);
  
  // Count cards by section
  const sectionCounts = {};
  sortedCards.forEach(card => {
    sectionCounts[card.section] = (sectionCounts[card.section] || 0) + 1;
  });
  
  // console.log('Cards by section:', sectionCounts);
  
  // Count by card type
  const cardTypeCounts = {
    'Monster': 0,
    'Magic': 0,
    'Trap': 0,
    'Other': 0
  };
  
  sortedCards.forEach(card => {
    if (card.cardType.includes('Monster')) {
      cardTypeCounts.Monster++;
    } else if (card.cardType.includes('Magic')) {
      cardTypeCounts.Magic++;
    } else if (card.cardType.includes('Trap')) {
      cardTypeCounts.Trap++;
    } else {
      cardTypeCounts.Other++;
    }
  });
  
  // console.log('Cards by type:', cardTypeCounts);

  return sortedCards;
};

export default parseCards;
